import { ButtonContentLink } from 'fukku/Button/ContentLink'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

interface EditBankDataButtonProps {
	readonly label: string
	readonly handleEdit?: () => void
}

export function EditBankDataButton({
	label,
	handleEdit,
}: EditBankDataButtonProps) {
	const { t } = useLabels()
	return (
		<ButtonContentLink onClick={handleEdit} data-testid={label}>
			{t(label)}
		</ButtonContentLink>
	)
}
